'use strict';

angular.module('formonlineApp')
    .controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
 		$scope.setCurrent = function (language) {
			$scope.language = language;
		};

        $scope.changeLanguage = function (languageKey) {
			$translate.use(languageKey).then($scope.setCurrent);
            tmhDynamicLocale.set(languageKey);
		};

        Language.getAll().then(function (languages) {
            $scope.languages = languages;
		});

		$scope.language = $translate.proposedLanguage();
		if (!$scope.language) {
			$scope.language = $translate.use();
		}

    });
